const getters = {
	// Информация для формы - Оплата (каналы)
	payChannelDetailGetters: (state: { payChannelDetailState: object }) =>
		state.payChannelDetailState,

	// Покупка каналов
	payChannelGetters: (state: { payChannelState: object }) =>
		state.payChannelState,

	// Пополнение
	payBalanceGetters: (state: { payBalanceState: object }) =>
		state.payBalanceState,

	// Успешное пополнение
	paySuccessGetters: (state: { paySuccessState: object }) =>
		state.paySuccessState,

	// Оплата не прошла
	payFailGetters: (state: { payFailState: object }) => state.payFailState,

	// Количество активированных каналов
	payActivatedChannelsGetters: (state: { payActivatedChannelsState: object }) =>
		state.payActivatedChannelsState,

	// Баланс клиента
	payGetBalanceGetters: (state: { payGetBalanceState: number | null }) =>
		state.payGetBalanceState,

	// История покупок
	payHistoryGetters: (state: { payHistoryState: [] }) => state.payHistoryState,

	// Покупка опций
	payOptionsGetters: (state: { payOptionsState: object }) =>
		state.payOptionsState,

	// Покупка опций прошла успешно
	payOptionsSuccessGetters: (state: { payOptionsSuccessState: object }) =>
		state.payOptionsSuccessState,

	// Связь опций с инстансом
	payOptionsLnkInstanceGetters: (state: { payOptionsLnkInstanceState: [] }) =>
		state.payOptionsLnkInstanceState,

	// Автопродление опции (для checkbox)
	autoRenewalOptionGetters: (state: { autoRenewalOptionState: object }) =>
		state.autoRenewalOptionState,

	// Продление опций
	payOptionsRenewalGetters: (state: { payOptionsRenewalState: object }) =>
		state.payOptionsRenewalState,
};
export default getters;
